<template>
  <div
    v-if="params.data"
    class="d-flex flex-row align-items-center"
  >
    <p
      class="action plot"
      @click="plotTrade(params.data)"
    >
      Plot
    </p>
    <p :class="'result ' + resultText">
      {{ result.toFixed(2) }}%
    </p>
  </div>
</template>

<script>

export default {
  name: 'RendAnalysisPlot',
  data() {
    return {
      params: null,
      result: null,
      resultText: null,
    }
  },
  beforeMount() {
    // this.params contains the cell & row information and is made available to this component at creation time
    this.analysisPlotRend(this.params)
  },
  methods: {
    analysisPlotRend(params) {
      this.params = params
      this.result = params.data.result.signal
      if (this.result > 0) {
        this.resultText = 'win'
      } else this.resultText = 'loss'
    },
    plotTrade(data) {
      this.$router.push({
        name: 'plotTrade',
        params: {
          tradeId: data.id,
          initialTrade: data,
          initialType: 'analysis',
        },
      })
    },
  },
}
</script>

<style>
</style>
